import React from 'react';
import PlayerProfile from './sub/PlayerProfile';
import BatterPlayerSeasonRecord from './sub/BatterPlayerSeasonRecord';
import PitcherPlayerSeasonRecord from './sub/PitcherPlayerSeasonRecord';

function ProfileMain(props) {
    let playerObj = props['profile'];
    let {type} = playerObj;
    let {leagueType} = props; 

    return (
        <>
        <PlayerProfile profile={playerObj}/>
        {
        type === 'batter'
        ?
        <BatterPlayerSeasonRecord profile={playerObj} leagueType={leagueType}/>
        :
        <PitcherPlayerSeasonRecord profile={playerObj} leagueType={leagueType}/>
        }
        </>
    );
}

export default ProfileMain;